export default "__VITE_ASSET__DjDEKbwJ__"